import Commons from '../../../../Services/Common/Common';

/**
 * 공종 관리 (Gongjong) 스키마
 * - 조회1: GetDepLast (부서 목록) - CustCd, SearchText
 * - 조회2: GetGonBasicR1 (공정 목록, 부서 기준) - DepCd
 */
export const GON_BASIC_Schema = {
  fields: {
    no: { initial: '', label: 'NO' },
    depCd: { initial: '', label: '부서코드' },
    depNm: { initial: '', label: '부서' },
    gongjongCd: { initial: '', label: '공정코드' },
    gongjongNm: { initial: '', label: '공정명' },
  },

  mapper: {
    /** GetDepLast 부서 목록 조회 파라미터 */
    search1: {
      CustCd: (_, context) =>
        Commons.EncryptAES(context.search?.custCd || '') || '',
      SearchText: (_, context) =>
        Commons.EncryptAES(context.search?.searchText || '') || '',
    },
    /** GetGonBasicR1 공정 조회 파라미터 (부서 클릭 시) */
    search2: {
      DepCd: (_, context) =>
        Commons.EncryptAES(context.depCd || '') || '',
    },
    /** SaveGonBasicU1 공정 저장 (GongjongCd 비어있으면 INSERT, 있으면 UPDATE) */
    save1: {
      GongjongCd: (row) => Commons.EncryptAES(row.gongjongCd || '') || '',
      CustCd: (_, context) =>
        Commons.EncryptAES(context.search?.custCd || '') || '',
      DepCd: (row) => Commons.EncryptAES(row.depCd || '') || '',
      GongjongNm: (row) => Commons.EncryptAES(row.gongjongNm || '') || '',
      UseYn: (row) => Commons.EncryptAES(row.useYn || 'Y') || '',
      UserId: (_, context) => context.userInfo?.userid|| '',
    },
    /** DeleteGonBasicD1 공정 삭제 요청 (GongjongCd) */
    delete1: {
      GongjongCd: (row) => Commons.EncryptAES(row.gongjongCd || '') || '',
    },
  },
};
